import { render, staticRenderFns } from "./TherapistIncome.vue?vue&type=template&id=109981df"
import script from "./TherapistIncome.vue?vue&type=script&lang=js"
export * from "./TherapistIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports